<script setup lang="ts">
const { t } = useTexts();
const { isUserV2Enabled } = useFeatureFlagsJson();

useSeo({
  title: t('account.wallet.last_withdraw.title'),
});
</script>

<template>
  <UserV2ScreenLastWithdraw v-if="isUserV2Enabled" />
  <UserAccountPageLayout
    v-else
    on-back="user-wallet"
    :title="$t('account.wallet.last_withdraw.title')"
  >
    <div :class="$style.walletTransactions">
      <UserWalletTransactions show-only-this-tab="withdrawals" />
    </div>
  </UserAccountPageLayout>
</template>

<style module lang="scss">
.walletTransactions {
  @apply w-full h-auto m-0 max-w-[792px];
}
</style>
